export enum HttpRequestHeader {
  ACCEPT_LANGUAGE = "Accept-Language",
  CONTENT_TYPE = "Content-Type",
}

export enum HttpResponseHeader {
  CONTENT_DISPOSITION = "Content-Disposition",
}
